import EmployeeEntryTable from "./EmployeeEntryTable";

export default function DateHistoryRow({
  dateRow,
  isOpen,
  onToggle,
}) {
  return (
    <>
      {/* ================= PARENT DATE ROW ================= */}
      <tr className="bg-gray-50 hover:bg-gray-100 align-middle">
        <td className="px-4 py-3 font-semibold whitespace-nowrap">
          {dateRow.date}
        </td>

        <td className="px-4 py-3 text-center">
          <span
            className="badge bg-primary"
            style={{ padding: "4px", borderRadius: "12px", color: "#fff" }}
          >
            {dateRow.total_employees}
          </span>
        </td>

        <td className="px-4 py-3 text-end">
          {money(dateRow.totals?.gross_pay)}
        </td>

        <td className="px-4 py-3 text-end">
          {money(dateRow.totals?.taxable_gross)}
        </td>

        <td className="px-4 py-3 text-end text-danger">
          {money(dateRow.totals?.tax)}
        </td>

        <td className="px-4 py-3 text-end">
          {money(dateRow.totals?.employee_nics)}
        </td>

        <td className="px-4 py-3 text-end">
          {money(dateRow.totals?.employer_nics)}
        </td>

        <td className="px-4 py-3 text-end text-success font-semibold">
          {money(dateRow.totals?.net_pay)}
        </td>

        <td className="px-4 py-3 text-center">
          <button
            onClick={onToggle}
            className="btn btn-sm btn-outline-primary"
            aria-label="Toggle details"
          >
            {isOpen ? "▼" : "▶"}
          </button>
        </td>
      </tr>

      {/* ================= EXPANDED ENTRIES ================= */}
      {isOpen && (
        <tr>
          {/* 👇 MUST MATCH NUMBER OF TABLE COLUMNS (9) */}
          <td colSpan={9} className="bg-gray-100 px-4 py-5">
            <div className="bg-white border rounded-lg shadow-sm p-4">
              <h6 className="mb-3 font-semibold text-gray-700">
                Employee Details for {dateRow.date}
              </h6>

              <div className="overflow-x-auto">
                <EmployeeEntryTable entries={dateRow.entries || []} />
              </div>
            </div>
          </td>
        </tr>
      )}
    </>
  );
}

/* ================= HELPER ================= */

function money(value) {
  if (value === null || value === undefined) return "-";
  return `£${Number(value).toFixed(2)}`;
}
